Service = App.loadClass 'core::Angular/Service'
CropYear = App.loadClass 'core::CropYear'

class exports.DataSidebarService extends Service
    constructor: (@http, @rootScope, @loader) ->
        @data = []
        @page_loading = false
        @crop_year = (new CropYear()).get()

    lockSidebar: () =>
        @loader.overSidebar 'Loading...'

    unlockSidebar: () =>
        @loader.hideAll()

    initializePage: () ->
        @loader.overMapAndSidebar 'Loading...'
        @page_loading = true

    pageLoaded: () ->
        @loader.hideAll()
        @page_loading = false

    downloadRx: (id) =>
        return @http.post 'backend/grower/data/download',
            id: id


    getOperations: () ->
        operations = [
            'Ears, Rows, and Length',
            'Stand Count',
            'Harvest Load',
        ].sort()

        return operations


    postBulkDelete: (deleteArray) ->
        for layer in deleteArray

            id = layer.id
            layer_id = layer.layer_id
            layer_type = layer.layer_type

            switch (layer_type)
                when 'planting'
                    @http.post('backend/grower/layers/planting/delete', { id: id, layer_id: layer_id })
                when 'nitrogen'
                    @http.post('backend/grower/layers/nitrogen/delete', { id: id, layer_id: layer_id })
                when 'fertilizer'
                    @http.post('backend/grower/layers/fertilizer/delete', { id: id, layer_id: layer_id })
                when 'spraying'
                    @http.post('backend/grower/layers/spraying/delete', { id: id, layer_id: layer_id })
                when 'stand_count'
                    @http.post('backend/grower/layers/standcount/delete', { id: id, layer_id: layer_id })
                when 'ears_rows_length'
                    @http.post('backend/grower/layers/ears-rows-length/delete', { id: id, layer_id: layer_id })
                when 'harvest_load'
                    @http.post('backend/grower/layers/harvest-load/delete', { id: id, layer_id: layer_id })
                when 'prescription_map'
                    @http.post('backend/grower/layers/prescription-map/delete', { id: id, layer_id: layer_id })
                when 'shapefile'
                    @http.post('backend/grower/layers/shapefile/delete', { id: id, layer_id: layer_id })
                when 'planting_rx'
                    @http.post('backend/grower/layers/planting-rx/delete', { id: id, layer_id: layer_id })
                when 'management_zone'
                    @http.post('backend/grower/layers/management-zones/delete', { id: id, layer_id: layer_id })
                when 'cover_crop'
                    @http.post('backend/grower/layers/cover-crop/delete', { id: id,  layer_id: layer_id })

        return @http.post 'backend/grower/data/ng-bulk-delete-complete'


    getUserType: () ->
        return @http.post 'backend/grower/data/ng-get-user-type'


    loadFieldBoundary: (field_id) =>
        if not App.layer_store.exists(field_id)
            App.layer_store.empty()
            App.layer_store.loadField(field_id, { fillOpacity: 0.0 })

    checkArray: (array, value) =>
        for item in array
            return true if item is value
        return false